import moment from "moment";
import { Selected } from "../../dynamic/InfoTournament/types";
import React from "react";

export const mediaSizes = {
  smallMobile: 480,
  mobile: 768,
  tablet: 992,
  tabletLarge: 1024,
  desktop: 1200
};

/**
 * Gets media breakpoint based on window size
 * @param  {[type]} number [description]
 * @return {[type]} number [description]
 */

export const getMediaSize = (windowSize: number, disable: boolean = false) => {
  if (disable) {
    return windowSize;
  }
  return windowSize <= mediaSizes.mobile
    ? windowSize
    : windowSize <= mediaSizes.tablet && windowSize >= mediaSizes.mobile
    ? mediaSizes.mobile
    : windowSize <= mediaSizes.tabletLarge && windowSize >= mediaSizes.tablet
    ? mediaSizes.tablet
    : windowSize <= mediaSizes.desktop && windowSize >= mediaSizes.tabletLarge
    ? mediaSizes.tabletLarge
    : mediaSizes.desktop;
};

/**
 * Gets device label [Desktop, Tablet, Mobile] based on window size
 * @param  {[type]} number [description]
 * @return {[type]} number [description]
 */

export const getMediaDevice = (getMediaSizeFlag: boolean = false) => {
  const device =
    getMediaSize(window.innerWidth, getMediaSizeFlag) < mediaSizes.mobile
      ? "MOBILE"
      : getMediaSize(window.innerWidth, getMediaSizeFlag) >=
          mediaSizes.mobile &&
        getMediaSize(window.innerWidth, getMediaSizeFlag) <
          mediaSizes.tabletLarge
      ? "TABLET"
      : getMediaSize(window.innerWidth, getMediaSizeFlag) >=
          mediaSizes.tabletLarge &&
        getMediaSize(window.innerWidth, getMediaSizeFlag) < mediaSizes.desktop
      ? "DESKTOP"
      : "DESKTOPXL";
  return device;
};

/**
 * Flattens respond from youtube API
 * @param  {[type]} array [description]
 * @return {[type]} array [description]
 */

export const serializeVideoData = (data: any[]) => {
  return data.map(({ snippet }: any) => ({
    id: snippet.resourceId ? snippet.resourceId.videoId : "",
    ...snippet
  }));
};

/**
 * format date
 * @param  {[type]} date [description]
 * @return {[type]}      [description]
 */
export const formatDate = (date: any) => {
  const mDate = moment.isMoment(date) ? date : moment(date);
  if (!mDate.isValid()) return {};

  const fullYear = mDate.format("MMMM Do YYYY");
  const full = mDate.format("dddd Do MMMM");
  const raw = mDate.format("YYYY-MM-DD");
  const rawSlash = mDate.format("DD/MM/YYYY");
  const rawYearMonth = mDate.format("YYYY-MM");
  const rawMonth = mDate.format("MMMM");
  const rawYear = mDate.format("YYYY");
  const longNoYear = mDate.format("D MMMM");
  const short = mDate.format("D MMM, YYYY");
  const shortNoYear = mDate.format("D MMM");
  const longtNoComma = mDate.format("D MMMM YYYY");
  const longtNoDay = mDate.format("MMMM YYYY");
  const shortNoComma = mDate.format("D MMM YYYY");
  const standard = mDate.format("ddd, D MMM YYYY");
  const unix = mDate.format("x");
  const timeAgo = mDate.fromNow().replace(" ago", "");

  return {
    full,
    raw,
    rawSlash,
    rawYearMonth,
    rawMonth,
    longNoYear,
    longtNoComma,
    short,
    shortNoYear,
    shortNoComma,
    longtNoDay,
    fullYear,
    unix,
    standard,
    rawYear,
    timeAgo
  };
};

/**
 * new next/prev article item
 * @param  {[type]} object [description]
 * @return {[type]}      [description]
 */
export const formatNewsStoryItems = (data: any) => {
  let prevStory = null;
  let nextStory = null;

  if (data.previousNewsItem) {
    prevStory = {
      ...data.previousNewsItem,
      link: data.previousNewsItem.articleUrl,
      date: data.previousNewsItem.displayDate
    };
  }

  if (data.nextNewsItem) {
    nextStory = {
      ...data.nextNewsItem,
      link: data.nextNewsItem.articleUrl,
      date: data.nextNewsItem.displayDate
    };
  }

  return { ...data, prevStory, nextStory };
};

export const serializeArray = (form: any) => {
  // Setup our serialized data
  var serialized = [];

  // Loop through each field in the form
  for (var i = 0; i < form.elements.length; i++) {
    var field = form.elements[i];

    // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
    if (
      !field.name ||
      field.disabled ||
      field.type === "file" ||
      field.type === "reset" ||
      field.type === "submit" ||
      field.type === "button"
    )
      continue;

    // If a multi-select, get all selections
    if (field.type === "select-multiple") {
      for (var n = 0; n < field.options.length; n++) {
        if (!field.options[n].selected) continue;
        serialized.push({
          name: field.name,
          value: field.options[n].value
        });
      }
    }

    // Convert field data to a query string
    else if (
      (field.type !== "checkbox" && field.type !== "radio") ||
      field.checked
    ) {
      serialized.push({
        name: field.name,
        value: field.value
      });
    }
  }

  return serialized;
};

interface setImageProps {
  mobileImage?: string | null;
  tabletImage?: string | null;
  desktopImage?: string | null;
  elClassName?: string;
  relativeUrl?: boolean | null;
}

export interface imgCrop {
  cropKey: string;
  imageUrl: string | null;
}

export const checkImage = ({
  images = [],
  size
}: {
  images: imgCrop[];
  size: string;
}) => {
  const array =
    images !== null ? images.filter((t: imgCrop) => t.cropKey == size) : [];
  const Url = array.length
    ? array[0].imageUrl
    : "no-image-set-for-this-viewport";
  return Url;
};

export const checkImageCrop = ({ images = [] }: { images: imgCrop[] }) => {
  return images.some((img: imgCrop) => !!img.imageUrl);
};

export const setResponsiveImage = ({
  tabletImage,
  mobileImage,
  desktopImage,
  elClassName
}: setImageProps) => {
  const func = () => {
    const imageUrl =
      getMediaSize(window.innerWidth) >= mediaSizes.mobile &&
      getMediaSize(window.innerWidth) < mediaSizes.tablet
        ? tabletImage
        : getMediaSize(window.innerWidth) >= mediaSizes.tablet
        ? desktopImage
        : mobileImage;

    const el: HTMLElement | null = document.querySelector(`.${elClassName}`);
    const elWrapper: HTMLElement | null = document.querySelector(
      `.responsive-img__wrapper .${elClassName}`
    );

    if (el !== null && imageUrl != undefined) {
      el.style.backgroundImage = `url(${process.env.HOST}${imageUrl})`;
      if (elClassName && elClassName.includes("hero-") && !elWrapper) {
        el.outerHTML = `<div class="responsive-img__wrapper">${el.outerHTML}</div>`;
      }
    }
  };

  debounce({ func, delay: 250 });
  func();
};

export const collapseRegion = ({
  collapseHeight,
  elClassName
}: {
  collapseHeight?: number;
  elClassName?: string;
}) => {
  const btn = document.querySelector(
    `.${elClassName}-container .btn--read-more .text`
  );
  const btnWrapper: HTMLElement | null = document.querySelector(
    `.${elClassName}-container .btn--read-more`
  );
  const section: HTMLElement | null = document.querySelector(`.${elClassName}`);
  const children = document.querySelectorAll<HTMLElement>(
    `.${elClassName} section`
  );
  let totalHeight: number = 0;

  if (children !== null) {
    totalHeight = Array.from(children)
      .map(el => el.offsetHeight, 0)
      .reduce((acc, currentValue) => acc + currentValue, 0);
  }

  if (btnWrapper !== null && collapseHeight !== undefined && section !== null) {
    section.style.maxHeight = `${
      btnWrapper.classList.contains("collapse") ? collapseHeight : totalHeight
    }px`;

    btnWrapper.onclick = () => {
      if (section !== null && btn !== null) {
        btnWrapper.classList.toggle("collapse");
        if (btnWrapper.classList.contains("collapse")) {
          section.style.maxHeight = `${collapseHeight}px`;
        } else {
          section.style.maxHeight = `${totalHeight}px`;
        }
        btn.innerHTML = `Read ${
          btnWrapper.classList.contains("collapse") ? "more" : "less"
        }`;
      }
    };
  }
};

/**
 * debounce function that attaches to window.resize event
 * @param  {[type]} object [description]
 */

export const debounce = ({
  delay = 125,
  func,
  condition = null,
  event = "resize",
  timeOut = null
}: {
  delay?: number;
  func: Function;
  condition?: null | boolean;
  event?: string;
  timeOut?: null | ReturnType<typeof setTimeout>;
}) => {
  let timeout = timeOut;

  const execResize = (eventData: Event | WheelEvent) => {
    if (timeout !== null) {
      clearTimeout(timeout);
      timeout = null;
    }

    timeout = setTimeout(() => {
      timeout = null;
      if ((condition !== null && condition == true) || condition == null) {
        func({ condition, eventData });
      }
    }, delay);
  };

  window.addEventListener(event, execResize);
  return execResize;
};

export const throttle = function({
  func,
  delay = 500,
  event = "scroll",
  elClassName = null
}: {
  func: (event: Event) => void;
  delay?: number;
  event: string;
  elClassName?: string | null;
}) {
  let isThr = false;

  const fn = (event: Event) => {
    if (!isThr) {
      func(event);
      isThr = true;

      setTimeout(() => {
        isThr = false;
      }, delay);
    }
  };

  const el = document.querySelector(`.${elClassName}`);

  (el || window).addEventListener(event, fn);

  return fn;
};

export const resizeVideos = ({ ElClassName }: { ElClassName: string }) => {
  let width: number;
  let items: Object[] = [];
  const videos: NodeList = document.querySelectorAll(`.${ElClassName}`);
  if (videos !== null) {
    Array.from(videos).map((item: HTMLElement) => {
      width = item.offsetWidth;
      item.style.height = `${
        width * (9 / 16) > 280 ? width * (9 / 16) : 280
      }px`;
      items.push({ item, width });
    });
  }
};

export const createLabel = (array: any[]) => {
  return array.map((op, index: number) => ({
    ...op,
    value: `${op.id}-${index}`,
    label: op.name,
    selected: array.length === 1
  }));
};

export const mapRoundLabelForMob = (round: string) => {
  switch (round) {
    case "1st Round":
      return "R1";
    case "2nd Round":
      return "R2";
    case "3rd Round":
      return "R3";
    case "4th Round":
      return "R4";
    case "Quarterfinal":
    case "Quarter-final":
    case "Quarterfinals":
    case "Quarter-finals":
      return "QF";
    case "Semifinal":
    case "Semi-final":
    case "Semifinals":
    case "Semi-finals":
      return "SF";
    case "Final":
      return "F";
    default:
      return round;
  }
};

export const checkSelected = (selected: Selected) => {
  let newObject = Object.keys(selected).reduce((obj, key) => {
    if (selected[key]) {
      obj[key] = selected[key];
    }
    return obj;
  }, {});
  return newObject;
};

export const omitNation = (nationCode: string | null, blank = false) => {
  return nationCode == "RUS" ||
    nationCode == "RUSSIA" ||
    nationCode == "Russia" ||
    nationCode == "BLR" ||
    nationCode == "Belarus" ||
    nationCode == "BELARUS"
    ? blank
      ? "WHITE"
      : ""
    : nationCode;
};

export const isEsports = () =>
  location.pathname.indexOf("itf-world-tennis-esport") >= 0;

export const detachAndAppendElement = (target: string, appendTo: string) => {
  const element = document.querySelector(target);
  const appendElement = document.querySelector(appendTo);
  if (!element || !appendElement) return;
  const clone = element.cloneNode(true);
  appendElement.appendChild(clone);
  element.setAttribute("style", "display:none");
};

export const isOlympics =
  location.href.indexOf("lympics") >= 0 ||
  location.href.indexOf("limpicos") >= 0 ||
  location.href.indexOf("lympiques") >= 0;

export const isParalympics =
  location.href.indexOf("paralympics") >= 0 ||
  location.href.indexOf("paralímpicos") >= 0 ||
  location.href.indexOf("paralympiques") >= 0;

const Params = location.pathname.split("/").filter(path => path);
export const isSpecialEvent =
  Params.length >= 2 ? (Params[1] === "events" ? true : false) : false;
export const isNewsArticle =
  Params.length >= 2 ? (Params[1] === "news-and-media" ? true : false) : false;
export const isTourLanding =
  Params.length >= 2 ? (Params[1] === "itf-tours" ? true : false) : false;

export const stylesToString = (style: any) => {
  return Object.keys(style).reduce(
    (acc, key) => acc + key + ":" + style[key] + ";",
    ""
  );
};

export const getHexColor = (color: string) =>
  `${color.indexOf("#") === 0 ? color : "#" + color}`;

export function hexToRGBA(hex: string) {
  // @ts-ignore
  return (hex = hex.replace("#", ""))
    .match(new RegExp("(.{" + hex.length / 3 + "})", "g"))
    .map(function(l) {
      return parseInt(hex.length % 2 ? l + l : l, 16);
    });
}

export function ColorLuminance(hex: string, lum: number) {
  // validate hex string
  hex = String(hex).replace(/[^0-9a-f]/gi, "");
  if (hex.length < 6) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  lum = lum || 0;

  // convert to decimal and change luminosity
  var rgb: string = "#",
    c,
    i;
  for (i = 0; i < 3; i++) {
    c = parseInt(hex.substr(i * 2, 2), 16);
    c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
    rgb += ("00" + c).substr(c.length);
  }

  return rgb;
}

export const Arrow = ({ fill = "" }: { fill: string }) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 0L4.9425 1.0575L9.1275 5.25H0V6.75H9.1275L4.9425 10.9425L6 12L12 6L6 0Z"
      fill={fill}
    />
  </svg>
);

export const reg = {
  juniors: /^J[0-9]+/g,
  beach: /^BT[0-9]+/g,
  masters: /^MT[0-9]+/g,
  Mens: /^M[0-9]+/g,
  Womens: /^W[0-9]+/g
};

export const brandColours = {
  blue: ["M15", "W15", "W25", "M25", "W35", "W40", "W60", "W80"],
  red: ["W50", "W75", "W100"]
};

export const widthReg = /width=[0-99]+&/gi;
export const heightReg = /height=[0-99]+&/gi;

export const imageDimensionSet = ({
  url,
  width,
  height
}: {
  url: string | null;
  width: number;
  height: number;
}) => {
  return url !== null
    ? url
        .replace(widthReg, "width=" + width + "&")
        .replace(heightReg, "height=" + height + "&")
    : "";
};

export function uniqueBy<T, K extends keyof T>(arr: T[], key: K): T[] {
  return arr.filter(
    (item, index, self) =>
      index === self.findIndex(other => other[key] === item[key])
  );
}

export function HexToHSL(hex: string): { h: number; s: number; l: number } {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  if (!result) {
    throw new Error("Could not parse Hex Color");
  }

  const rHex = parseInt(result[1], 16);
  const gHex = parseInt(result[2], 16);
  const bHex = parseInt(result[3], 16);

  const r = rHex / 255;
  const g = gHex / 255;
  const b = bHex / 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);

  let h = (max + min) / 2;
  let s = h;
  let l = h;

  if (max === min) {
    // Achromatic
    return { h: 0, s: 0, l };
  }

  const d = max - min;
  s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
  switch (max) {
    case r:
      h = (g - b) / d + (g < b ? 6 : 0);
      break;
    case g:
      h = (b - r) / d + 2;
      break;
    case b:
      h = (r - g) / d + 4;
      break;
  }
  h /= 6;

  s = s * 100;
  s = Math.round(s);
  l = l * 100;
  l = Math.round(l);
  h = Math.round(360 * h);

  return { h, s, l };
}
